import React from 'react';
import RecNewsComponent from '../../components/RecNewsComponent/RecNewsComponent';
import SearchCategory from '../../components/SearchCategory/SearchCategory';

function SearchCategoryPage() {
  return (
    <>
      <SearchCategory />
      <RecNewsComponent />
    </>
  );
}

export default SearchCategoryPage;
